import { type Country, countryList } from '@/utils/countryList';
import { Autocomplete } from '@andritzot/metris-web-ui/inputs/autocomplete';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

interface CountryFieldProps {
  control: Control<FormProps>;
}

export function CountryField({ control }: Readonly<CountryFieldProps>) {
  return (
    <Controller
      name="country"
      control={control}
      rules={{ required: 'required' }}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete<Country, false, false, false>
          options={countryList}
          getOptionLabel={(opt) => opt.name}
          value={field.value}
          onChange={(_, val) => field.onChange(val)}
          isOptionEqualToValue={(opt, val) => opt.name === val.name}
          fullWidth
          size="medium"
          renderInput={(params) => (
            <TextField {...params} label="Country" required error={!!error} helperText={error?.message} fullWidth />
          )}
        />
      )}
    />
  );
}
